module.exports = __webpack_public_path__ + "img/product_4.ea1ea38d.png";